import.meta.glob([
    '../images/**',
]);

import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'

import * as Sentry from '@sentry/vue'

createInertiaApp({
    resolve: name => {
        const pages = import.meta.glob('./Pages/**/*.vue', { eager: true })
        return pages[`./Pages/${name}.vue`]
    },
    setup({ el, App, props, plugin }) {
        const app =createApp({ render: () => h(App, props) });

        Sentry.init({
            app,
            dsn: "https://44b1c618dd462a2ce9d80f0c1a0399a0@sentry.shumakov.online/3",
            sendDefaultPii: true
        });

        app.use(plugin)
            .mount(el)
    },
})
